import React, { useEffect, useState } from "react";
import { Col, Card } from "react-bootstrap";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import axios from "axios";
import EmptyState from "./EmptyState";

const RansomwareOverTimeChart = ({ queryParam, selectedOption }) => {
  const [data, setData] = useState([]);

  const getGranularity = (option) => {
    if (!option?.value) return "monthly";
    const value = option.value;
    if (value === "all_time" || value === "this_year" || value === "last_year") {
      return "monthly";
    }
    return "daily";
  };

  useEffect(() => {
    const granularity = getGranularity(selectedOption);
    const separator = queryParam?.includes("?") ? "&" : "?";
    const url = `${process.env.REACT_APP_EAS_BASE_URL}/api/ransomware/over-time${queryParam}${separator}granularity=${granularity}`;

    axios
      .get(url, {
        headers: {
          apikey: process.env.REACT_APP_EAS_API_KEY,
          "X-CloudManager-Id": process.env.REACT_APP_EAS_CLOUD_ID,
        },
      })
      .then((response) => {
        setData(response?.data?.data || []);
      })
      .catch((error) => console.error("Error fetching time data:", error));
  }, [queryParam, selectedOption]);

  const hasData = data?.length > 0;

  const formatPeriod = (period) => {
    if (!period) return "";
    if (period.includes("W")) {
      return period;
    }
    if (period.length === 7) {
      const [year, month] = period.split("-");
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      return `${monthNames[parseInt(month, 10) - 1]} ${year}`;
    }
    if (period.length === 10) {
      const [year, month, day] = period.split("-");
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      return `${monthNames[parseInt(month, 10) - 1]} ${parseInt(day, 10)}`;
    }
    return period;
  };

  return (
    <Col md={12} className="mb-4">
      <Card style={{ minHeight: "360px" }}>
        <Card.Body>
          <h6 className="fw-bold text-muted">Ransomware Incidents Over Time</h6>
          {!hasData ? (
            <EmptyState title="No data found" />
          ) : (
            <ResponsiveContainer width="100%" height={300}>
              <AreaChart
                data={data}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="period" tickFormatter={formatPeriod} />
                <YAxis />
                <Tooltip
                  labelFormatter={formatPeriod}
                  formatter={(value) => [value, "Incidents"]}
                />
                <Legend />
                <Area
                  type="monotone"
                  dataKey="count"
                  stroke="#e74c3c"
                  fill="#e74c3c"
                  fillOpacity={0.3}
                  name="Incidents"
                />
              </AreaChart>
            </ResponsiveContainer>
          )}
        </Card.Body>
      </Card>
    </Col>
  );
};

export default RansomwareOverTimeChart;
